export const blockCountQueryParameter = "bc";
export const lastShownKey = "new_tab_last_shown";
export const coolDownPeriodKey = "new_tab_cool_down";
export var NewTabEventType;
(function (NewTabEventType) {
    NewTabEventType["created"] = "tab_created";
    NewTabEventType["loaded"] = "tab_loaded";
    NewTabEventType["received"] = "received";
    NewTabEventType["has_content"] = "has_content";
})(NewTabEventType || (NewTabEventType = {}));
export var NewTabErrorEventType;
(function (NewTabErrorEventType) {
    NewTabErrorEventType["noBehaviorFound"] = "error_no_behavior";
    NewTabErrorEventType["licenseStateNoMatch"] = "license_state_no_match";
    NewTabErrorEventType["noUrlFound"] = "error_no_url";
    NewTabErrorEventType["tabCreationError"] = "tab_creation_error";
})(NewTabErrorEventType || (NewTabErrorEventType = {}));
export var NewTabExitEventType;
(function (NewTabExitEventType) {
    NewTabExitEventType["admin"] = "newtab_admin";
    NewTabExitEventType["disabled"] = "newtab_disabled";
})(NewTabExitEventType || (NewTabExitEventType = {}));
